import React, { useRef } from 'react';
import { Download, Upload } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';

export const downloadJson = (name, data) => {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob); a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
};

export const ExportImport = ({ kind, onExport, onImport, testId, compact = false }) => {
  const input = useRef(null);
  const pick = async (e) => {
    const f = e.target.files?.[0]; e.target.value = '';
    if (!f) return;
    try {
      const parsed = JSON.parse(await f.text());
      if (parsed.kind && parsed.kind !== kind) { toast.error(`This file contains ${parsed.kind}, not ${kind}.`); return; }
      await onImport(parsed.items ? parsed : { kind, items: Array.isArray(parsed) ? parsed : [parsed] });
    } catch (err) { toast.error('Could not read this file as JSON.'); }
  };
  return (
    <div className="flex gap-1.5">
      <Button size="sm" variant="outline" data-testid={`${testId}-export`} onClick={onExport} title={compact ? 'Export JSON' : undefined} aria-label="Export JSON" className={compact ? 'h-8 w-8 p-0' : ''}><Download className={compact ? 'h-3.5 w-3.5' : 'h-3.5 w-3.5 mr-1.5'} />{!compact && 'Export'}</Button>
      <Button size="sm" variant="outline" data-testid={`${testId}-import`} onClick={() => input.current?.click()} title={compact ? 'Import JSON' : undefined} aria-label="Import JSON" className={compact ? 'h-8 w-8 p-0' : ''}><Upload className={compact ? 'h-3.5 w-3.5' : 'h-3.5 w-3.5 mr-1.5'} />{!compact && 'Import'}</Button>
      <input ref={input} type="file" accept="application/json,.json" className="hidden" data-testid={`${testId}-import-input`} onChange={pick} />
    </div>
  );
};
